import {z} from 'zod';
import {Sorting} from '@brunata-angular/ui';
import {
    caseInsensitiveComparator,
    composeComparators,
    keyComparator,
    zDateTimeAsSent,
} from '@brunata-angular/util';

export const archivedOrderSchema = z.object({
    documentLink: z.string(),
    receiptDate: zDateTimeAsSent.nullable(),
    workType: z.string(),
});

export type ArchivedOrder = z.infer<typeof archivedOrderSchema>;

export const defaultServiceWorkSorting: Sorting = {column: 'receiptDate', direction: 'desc'};

// A receipt without a date stays at the bottom in both directions.
const byReceiptDate = (
    direction: Sorting['direction'],
): ((first: ArchivedOrder, second: ArchivedOrder) => number) =>
    keyComparator(order => order.receiptDate?.toMillis() ?? null, direction, 'last');

/** Rows that tie on the chosen column keep the newest receipt first. */
export function sortServiceWorkRows(
    orders: readonly ArchivedOrder[],
    sorting: Sorting,
    workTypeLabel: (workType: string) => string,
): ArchivedOrder[] {
    const columnComparator =
        sorting.column === 'workType'
            ? caseInsensitiveComparator<ArchivedOrder>(
                  order => workTypeLabel(order.workType),
                  sorting.direction,
              )
            : byReceiptDate(sorting.direction);
    return [...orders].sort(composeComparators([columnComparator, byReceiptDate('desc')]));
}
